import hammerConfig from './Hammer/Config';
import nuclearGaugeConfig from './NuclearDensityGaugeStandardisation/Config';
import sieveSetConfig from './SieveSet/Config';
import equipmentTypes from './equipmentTypes';

export * from './EquipmentLabel';
export * from './EquipmentStatus';
export { equipmentTypes };

export const config = {
  ...hammerConfig,
  ...sieveSetConfig,
  ...nuclearGaugeConfig,
};
